
/* SUGGEST */
// Inicializa o comportamento dos campos do tipo sugestão
// Executada no load da wfflow_Execute
execv2.form.processSuggestions = function () {
    document.querySelectorAll("input[data-special-type='suggest'][data-c]").forEach(function (field) {
        const row = field.closest('tr');

        if (row && row.closest('table[mult=S]')) {
            execv2.form.setSuggestionField(field, row);
            return;
        }

        execv2.form.setSuggestionField(field);
    });
}

execv2.form.processSuggestionsTable = function (newRow) {
    newRow.querySelectorAll("input[data-special-type='suggest'][data-c]").forEach(function (field) {
        execv2.form.setSuggestionField(field, newRow);
    });
}

execv2.form.setSuggestionField = function (suggestionField, row) {
    function _processSuggestionsError(label, message) {
        console.log(label + "\n" + message);
    }

    var $suggest = $(suggestionField);
    var c = $suggest.attr("data-c");

    if (!c) return;

    var label = $suggest.attr("label");
    var options = [];
    var othersFieldsAltered = [];
    var $container = $suggest.parent();
    var timeout;
    var keyToCodField = "cod" + $suggest.attr("xname").replace("inp", "");
    let valueBefore = $suggest.val();

    //ao tirar o foco do campo
    $suggest.off("blur.processSuggestions").on("blur.processSuggestions", function () {
        const attr = $suggest.attr("data-setbytypeahed");

        if (!attr || attr === 'false' || !$suggest.val()) {
            $suggest.val('');

            execv2.form.fillValue(keyToCodField, '', suggestionField);

            //limpa todas as referencias antes preenchidas
            othersFieldsAltered = $suggest.attr("others_altered") != null ? $suggest.attr("others_altered").split(",") : [];

            for (const field of othersFieldsAltered) {
                execv2.form.fillValue(field, '', suggestionField);
            }
        }

        //após 4 milissegundos do evento de blur, se o valor do campo estiver diferente do valor original,
        //é disparado um evento de change, que é capturado pela automação de campos
        //o timeout evita que o evento seja disparado múltiplas vezes (quando o usuário inicia a digitação, quando o campo é limpado, etc)
        setTimeout(() => {
            let value = $suggest.val();
            if (value != valueBefore)
                $suggest[0].dispatchEvent(new Event('suggest-change'));
        }, 400);
    });

    //o valor do campo foi preenchido pelo usuário e não pela consulta ajax
    $suggest.off("keypress.processSuggestions").on("keypress.processSuggestions", function () {
        $suggest.attr("data-setbytypeahed", false);
    });

    $suggest.typeahead({
        minLength: 3,
        source: function source(query, process) {
            clearTimeout(timeout);

            //timeout para melhorar a experiencia de digitação e economizar postbacks
            timeout = setTimeout(function () {
                //mostra o loading
                if ($container.find(".loading").length == 0) {
                    $container.append('<img src="../common/images/v3/loading_ajax.gif" width="16" class="loading">');
                }

                const optionsText = [];
                options = [];

                const queryString = getQueryStringOfFieldsFromRowAndOutsideMultipleTable(row);

                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: "../api/internal/legacy/1.0/datasource/get/1.0/" + c,
                    data: `f=${encodeURIComponent(query)}&n=10&${queryString}`
                })
                    .done(function (data) {
                        if (data.success != null) {
                            data.success.forEach(function (option) {
                                if (!optionsText.includes(option.txt)) {
                                    optionsText.push(option.txt);
                                }
                                options.push(option);
                            });

                            process(optionsText);
                        }
                        else if (data.error != null) {
                            _processSuggestionsError(label, data.error.FriendlyMessage);
                        }
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        _processSuggestionsError(label, errorThrown);
                    })
                    .always(function () {
                        $container.find(".loading").remove();
                    });
            }, 300);
        },
        matcher: function (item) {
            return true
        },
        updater: function (txt, autoLoad) {
            $suggest.attr("data-setbytypeahed", true);

            if (txt === undefined) return;

            const selectedOption = options.find(function (option) {
                return option.txt == txt || (autoLoad && option.cod == txt);
            });

            if (!selectedOption) return;

            execv2.form.fillValue(keyToCodField, selectedOption.cod, suggestionField);

            for (const field in selectedOption.fields) {
                if (('inp' + field) === $suggest.attr('xname')) continue;

                execv2.form.fillValue(field, selectedOption.fields[field], suggestionField);

                if (!othersFieldsAltered.includes(field)) {
                    othersFieldsAltered.push(field);
                }
            }

            $suggest.attr("others_altered", othersFieldsAltered);

            //após 4 milissegundos do item selecionado é disparado um evento de change, que é capturado pela automação de campos
            //o timeout permite que o valor retornado pela função updater seja setado no campo antes do evento disparar
            setTimeout(() => {
                $suggest[0].dispatchEvent(new Event('suggest-change'));
            }, 400);

            return txt;
        }
    });

    //Se o campo sugestão já possui um valor carregado na primeira tarefa, a fonte de dados é imediatamente executada.
    //Isso é feito apenas na primeira tarefa para evitar perda de dados (sobrescrita)
    if ($suggest.val() && !$("#inpCodFlowExecute").val()) {
        $suggest.data('typeahead').source($suggest.val(), function () {
            $($suggest).data('typeahead').updater($suggest.val(), true);
        });
    }

    $suggest.on('focus', (e) => {
        valueBefore = $suggest.val();
    });
}

execv2.form.getFieldsFromRowAndOutsideMultipleTable = function (row) {
    const fieldsSelector =
        'input[xname]:not([type=checkbox]):not([type=radio]), input[xname]:checked, select[xname], textarea[xname]';
    const boxFrmExecute =
        document.getElementById('BoxFrmExecute') ||
        document.getElementById('FrmExecute');

    const allFields = boxFrmExecute.querySelectorAll(fieldsSelector);

    if (allFields === null) return [];

    if (!row) return Array.from(allFields);

    const fieldsOutsideMultipleTable = [];
    const fieldsFromRow = Array.from(row.querySelectorAll(fieldsSelector));

    allFields.forEach(function (field) {
        const fieldXname = field.attributes.xname.value;

        if ((fieldsFromRow.find((fieldFromRow) => fieldFromRow.attributes.xname.value === fieldXname))) return;

        fieldsOutsideMultipleTable.push(field);
    });

    return [...fieldsFromRow, ...fieldsOutsideMultipleTable];
}

execv2.form.getQueryStringOfFieldsFromRowAndOutsideMultipleTable = function (row) {
    return getFieldsFromRowAndOutsideMultipleTable(row)
        .map(field => `${field.attributes.xname.value}=${encodeURIComponent(field.value)}`)
        .join('&');
}
